import { NEXT_PUBLIC_SITE_URL } from '@src/config/env'
import type { TRegionDetail } from '@src/config/localisation/locale-config.types'

const getPathNameWithoutLeadingSlash = (pathname: string) => {
  return pathname.startsWith('/') ? pathname.substring(1) : pathname
}

export const getLocalePath = (locale: string, pathnameWithoutLeadingSlash: string) => {
  switch (locale) {
    case 'en-us':
      return pathnameWithoutLeadingSlash // No locale prefix for US
    case 'en-ca':
      return `ca/${pathnameWithoutLeadingSlash}`
    case 'fr-ca':
      return `fr-ca/${pathnameWithoutLeadingSlash}`
    default:
      return pathnameWithoutLeadingSlash
  }
}

export const getAlternateTags = (
  isI18nPreviewEnabled: boolean,
  pathname?: string,
  regionDetails?: TRegionDetail,
  alternateUrls?: Record<string, string> | number[],
) => {
  if (!isI18nPreviewEnabled || !pathname || !regionDetails) return null

  const pathnameWithoutLeadingSlash = getPathNameWithoutLeadingSlash(pathname)

  if (Array.isArray(alternateUrls)) {
    const localeTags: JSX.Element[] = []

    alternateUrls.forEach(regionId => {
      const region = Object.values(regionDetails.regions).find(r => r.regionId.toString() === regionId.toString())

      if (region) {
        const supportedLocales = region.supportedLanguagesIsoCodes

        supportedLocales.forEach(locale => {
          const hreflang = locale.toLowerCase()
          const localePath = getLocalePath(locale, pathnameWithoutLeadingSlash)
          const url = `${NEXT_PUBLIC_SITE_URL}/${localePath}`

          localeTags.push(<link key={locale} rel="alternate" hrefLang={hreflang} href={url} />)
        })
      }
    })

    localeTags.push(
      <link
        key="x-default"
        rel="alternate"
        hrefLang="x-default"
        href={`${NEXT_PUBLIC_SITE_URL}/${pathnameWithoutLeadingSlash}`}
      />,
    )

    return localeTags
  }

  return null
}
